// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { memo } from 'preact/compat';
import PropTypes from 'prop-types';

import Search from './Search';
import MultiItemList from './MultiItemList';
import SingleItemList from './SingleItemList';
import Date from './Date';

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
const Facet = ( props ) => {
	const { kind } = props;

	switch ( kind ) {
			case 'search':
				return <Search {...props} />;
			case 'multiitemlist':
				return <MultiItemList {...props} />;
			case 'singleitemlist':
				return <SingleItemList {...props} />;
			case 'date':
				return <Date {...props} />;
			default:
				return null;
	}
};

Facet.defaultProps = {
	items: [],
};

Facet.propTypes = {
	group: PropTypes.string.isRequired,
	items: PropTypes.arrayOf( PropTypes.object ),
	label: PropTypes.string.isRequired,
	kind: PropTypes.string.isRequired,
};

export default memo( Facet );
